import type { AdminLocale } from './index';
import en from '@shopify/polaris/locales/en.json';
import fr from '@shopify/polaris/locales/fr.json';
import de from '@shopify/polaris/locales/de.json';
import es from '@shopify/polaris/locales/es.json';
import it from '@shopify/polaris/locales/it.json';
import nl from '@shopify/polaris/locales/nl.json';
import ptBR from '@shopify/polaris/locales/pt-BR.json';
import zhCN from '@shopify/polaris/locales/zh-CN.json';
import ja from '@shopify/polaris/locales/ja.json';

const POLARIS: Record<AdminLocale, typeof en> = {
  en,
  fr,
  de,
  es,
  it,
  nl,
  'pt-BR': ptBR,
  'zh-CN': zhCN,
  ja,
};

export function polarisI18n(locale: AdminLocale): typeof en {
  return POLARIS[locale] || en;
}
